export const CLIENT_STATUS_OPTIONS = [
  { value: 'new', label: 'Ещё не общались' },
  { value: 'no_answer', label: 'Не дозвонился' },
  { value: 'contacted', label: 'Созвонились' },
  { value: 'callback', label: 'Нужно перезвонить' },
  { value: 'interested', label: 'Есть интерес' },
  { value: 'not_interested', label: 'Неактуально' },
] as const

export type ClientStatus = (typeof CLIENT_STATUS_OPTIONS)[number]['value']

export interface Interaction {
  id: string
  createdAt: string
  status: ClientStatus
  outcome: string
  nextContactAt: string | null
}

export type LegalType = 'ЮЛ' | 'ИП'

export type GovernmentContractsStatus = 'yes' | 'not_found' | 'unknown'

export interface OsintContact {
  address: string
  phone: string
  email: string
  website: string
  source: string
  comment: string
}

export interface OsintContract {
  laws: string
  date: string | null
  price: number | null
  customer: string
  subject: string
  registryNumber: string
  url: string
}

export interface OsintTenderProfile {
  matchedName: string
  exactMatch: boolean
  winners: number
  completed: number
  total: number
  organizationUrl: string
  searchUrl: string
}

export interface ClientOsint {
  collectedAt: string
  sourceFile: string
  rank: number | null
  legalType: LegalType | ''
  revenue: number | null
  revenueYear: number | null
  revenueCategory: string
  segment: string
  companyStatus: string
  governmentContracts: GovernmentContractsStatus
  minimumContracts: number
  activity: string
  completeness: string
  classDemand: string
  profileClass: string
  kpp: string
  contact: OsintContact
  latestContract: OsintContract | null
  tenderProfile: OsintTenderProfile | null
  sources: string[]
}

export interface Client {
  id: string
  company: string
  taxId?: string
  contactPerson: string
  phone: string
  email: string
  city: string
  segment: string
  potential: number | null
  paymentTermsDays?: number
  status: ClientStatus
  important: boolean
  attempts: number
  lastContactAt: string | null
  nextContactAt: string | null
  result: string
  notes: string
  interactions: Interaction[]
  osint?: ClientOsint
  createdAt: string
  updatedAt: string
}

export type ProjectStatus = 'active' | 'archived'

export interface WorkProject {
  id: string
  number: string
  name: string
  clientId: string
  clientNameSnapshot: string
  status: ProjectStatus
  createdAt: string
  updatedAt: string
}

export type InvoiceStatus = 'issued' | 'shipped' | 'paid' | 'cancelled'

export interface Invoice {
  id: string
  number: string
  clientId: string
  clientNameSnapshot: string
  projectId: string | null
  projectNameSnapshot: string
  amountKopecks: number
  currency: 'RUB'
  issuedOn: string
  status: InvoiceStatus
  shippedOn: string | null
  paymentTermsDays: number
  paidOn: string | null
  createdAt: string
  updatedAt: string
}

export interface AppState {
  schemaVersion: 1
  clients: Client[]
  lastSavedAt: string | null
}

export type ImportField =
  | 'company'
  | 'taxId'
  | 'contactPerson'
  | 'phone'
  | 'email'
  | 'city'
  | 'segment'
  | 'potential'
  | 'notes'

export type ImportMapping = Record<ImportField, number | null>

export interface ParsedTable {
  filename: string
  headers: string[]
  rows: unknown[][]
  kind?: 'standard' | 'osint'
  osintRecords?: OsintClientRecord[]
}

export interface OsintClientRecord {
  company: string
  taxId: string
  osint: ClientOsint
}

export interface OsintImportResult {
  clients: Client[]
  created: number
  updated: number
  skipped: number
}
